const Tooltip = ({ children, text, position }) => {
  return (
    <div className="custom-tooltip-container">
      {children}
      <div className={`custom-tooltip-box custom-tooltip-${position}`}>
        {text}
      </div>
    </div>
  );
};

export default Tooltip;
